export default {
  title: 'Registrieren und Punkte sammeln',
  benefits: {
    earn_points: 'Sammeln Sie Punkte mit jeder Bestellung',
    get_deals: 'Erhalten Sie exklusive Rabatte',
    redeem_points: 'Tauschen Sie Punkte gegen kostenloses Essen ein',
  },
  terms: 'Mit der Registrierung erhalten Sie E-Mail- und SMS-Angebote von unserem&nbsp;',
  buttons: {
    log_in: 'Anmelden',
  },
  labels: {
    already_have_account: 'Bereits ein Konto?',
  },
  signup_note:
    'Mit der Registrierung erhalten Sie E-Mail- und SMS-Angebote von unserem <0>Restaurant</0> und <1>FoodAmigos</1>, unserem Technologiepartner. Sie stimmen unseren <2>Plattform-Bedingungen</2> und <3>Datenschutzrichtlinien</3> zu.',
};
